import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BaseEdge, EdgeLabelRenderer, type EdgeProps, getBezierPath } from "@xyflow/react";
import type { FC } from "react";
import { cardActionIconFor } from "./cardActionIcon";

export type CardActionEdgeData = {
  actionType: string;
  answerValue: string;
  sourceCardUuid: string;
  actionId: string;
};

// Color per actionType (Domain\ChecklistContent\ActionType, backend) — the same three values as the
// content editor's "copy to B" label system, reused here as a traffic-light color for the arrow.
export function colorForActionType(actionType: string): string {
  if (actionType === "green") return "#16a34a";
  if (actionType === "amber") return "#d97706";
  if (actionType === "red") return "#dc2626";
  return "#64748b";
}

export const CardActionEdge: FC<EdgeProps> = (props) => {
  const data = props.data as unknown as CardActionEdgeData;
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    sourcePosition: props.sourcePosition,
    targetX: props.targetX,
    targetY: props.targetY,
    targetPosition: props.targetPosition,
  });
  const color = colorForActionType(data.actionType);
  const icon = cardActionIconFor(data.answerValue);

  return (
    <>
      <BaseEdge
        id={props.id}
        path={edgePath}
        markerEnd={props.markerEnd}
        style={{ stroke: color, strokeWidth: 2 }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            borderColor: color,
          }}
          className={
            "bg-white border rounded-full px-2 py-0.5 text-xs font-medium text-slate-700 pointer-events-none flex items-center justify-center"
          }
        >
          {icon ? (
            <FontAwesomeIcon icon={icon} style={{ color }} />
          ) : (
            // Long free-text answers would otherwise stretch across the board; the action modal shows it all.
            <span className={"max-w-20 truncate"}>{data.answerValue}</span>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export const cardFlowEdgeTypes = {
  cardAction: CardActionEdge,
};
